"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _colors = require("HubStyleTokens/colors");

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _dateHelpers = require("crm_ui/utils/dateHelpers");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _classnames = _interopRequireDefault(require("classnames"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _EngagementRecord = _interopRequireDefault(require("customer-data-objects/engagement/EngagementRecord"));

var _ObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ObjectTypesType"));

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _Small = _interopRequireDefault(require("UIComponents/elements/Small"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UIIconCircle = _interopRequireDefault(require("UIComponents/icon/UIIconCircle"));

var _UIColumn = _interopRequireDefault(require("UIComponents/column/UIColumn"));

var _UIColumnSpreads = _interopRequireDefault(require("UIComponents/column/UIColumnSpreads"));

var _UIColumnWrapper = _interopRequireDefault(require("UIComponents/column/UIColumnWrapper"));

var _debounce = _interopRequireDefault(require("transmute/debounce"));

var _TimelineEventHeaderButtons = _interopRequireDefault(require("crm_ui/timeline/components/generic/header/TimelineEventHeaderButtons"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var HEADER_ACTIONS_LINE_HEIGHT = 24;
var HEADER_ACTIONS_LEFT_PADDING = 8;
var propTypes = {
  canEdit: _propTypes.default.bool,
  disableDelete: _propTypes.default.bool,
  disableTimestamp: _propTypes.default.bool,
  engagement: _propTypes.default.instanceOf(_EngagementRecord.default),
  extraHeaderActions: _propTypes.default.array,
  handleOpenSelect: _propTypes.default.func,
  icon: _propTypes.default.string.isRequired,
  isHovering: _propTypes.default.bool,
  isPinned: _propTypes.default.bool,
  objectTypesToAssociate: _propTypes.default.arrayOf(_ObjectTypesType.default),
  onDeleteConfirm: _propTypes.default.func,
  subject: _SubjectType.default,
  timestamp: _propTypes.default.number,
  titleOptions: _propTypes.default.object,
  typeTitle: _propTypes.default.string.isRequired,
  useDefaultAssociationSelect: _propTypes.default.bool,
  useEditableTimestamp: _propTypes.default.bool,
  viewOnlyActions: _propTypes.default.array
};
var defaultProps = {
  isPinned: false,
  objectTypesToAssociate: [_ObjectTypes.CONTACT, _ObjectTypes.COMPANY, _ObjectTypes.DEAL, _ObjectTypes.TICKET],
  onDeleteConfirm: _emptyFunction.default,
  useDefaultAssociationSelect: true,
  canEdit: true,
  disableDelete: false
};

var TimelineHeader =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(TimelineHeader, _PureComponent);

  function TimelineHeader() {
    var _this;

    (0, _classCallCheck2.default)(this, TimelineHeader);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TimelineHeader).call(this));
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.state = {
      isSelectOpen: false,
      headerIsWrapping: false,
      headerActionsHeight: 0
    };
    _this.partial = (0, _ComponentMethods.makePartial)();
    _this.timelineHeaderElement = null;

    _this.timelineHeader = function (element) {
      _this.timelineHeaderElement = element;
    };

    _this.debounceCalculateWrap = (0, _debounce.default)(500, _this.calculateWhetherToWrap.bind((0, _assertThisInitialized2.default)(_this)));
    return _this;
  }

  (0, _createClass2.default)(TimelineHeader, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.debounceCalculateWrap);
      this.debounceCalculateWrap();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (this.props.isHovering !== prevProps.isHovering) {
        this.debounceCalculateWrap();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.debounceCalculateWrap);
    }
  }, {
    key: "getElement",
    value: function getElement(className) {
      return this.timelineHeaderElement.querySelector(className);
    }
  }, {
    key: "calculateWhetherToWrap",
    value: function calculateWhetherToWrap() {
      if (!this.hasHoverActions() || !this.timelineHeaderElement || !this.props.canEdit) {
        return null;
      }

      var availableSpaceForActions = this.getElement('.timeline-header-actions-and-timestamp').offsetWidth - HEADER_ACTIONS_LEFT_PADDING;
      var timestampWidth = this.getElement('.timeline-header-timestamp') ? this.getElement('.timeline-header-timestamp').offsetWidth : 0;
      var actionsWidth = this.getElement('.timeline-header-actions').offsetWidth;
      var headerIsWrapping = availableSpaceForActions - timestampWidth <= actionsWidth;

      if (headerIsWrapping) {
        var actionsAreWrapping = actionsWidth >= availableSpaceForActions;
        var headerActionsHeight = actionsAreWrapping ? HEADER_ACTIONS_LINE_HEIGHT * 2 : HEADER_ACTIONS_LINE_HEIGHT;
        return this.setState({
          headerIsWrapping: headerIsWrapping,
          headerActionsHeight: headerActionsHeight
        });
      }

      return this.setState({
        headerIsWrapping: false
      });
    }
  }, {
    key: "getActionsHeight",
    value: function getActionsHeight() {
      if (!this.state.headerIsWrapping) {
        return {};
      }

      return {
        height: this.state.headerActionsHeight
      };
    }
  }, {
    key: "getActionsClasses",
    value: function getActionsClasses() {
      return (0, _classnames.default)('timeline-header-actions', {
        'timeline-header-actions--collapsed': !this.shouldShowActions(),
        'timeline-header-actions--wrapped-and-collapsed': this.state.headerIsWrapping && !this.shouldShowActions(),
        'timeline-header-actions--wrapped': this.state.headerIsWrapping
      });
    }
  }, {
    key: "shouldShowActions",
    value: function shouldShowActions() {
      return this.props.isHovering || this.state.isSelectOpen;
    }
  }, {
    key: "hasHoverActions",
    value: function hasHoverActions() {
      return !!this.props.engagement || !!this.props.extraHeaderActions;
    }
  }, {
    key: "handleOpenSelect",
    value: function handleOpenSelect() {
      this.setState({
        isSelectOpen: true
      });
    }
  }, {
    key: "handleCloseSelect",
    value: function handleCloseSelect() {
      this.setState({
        isSelectOpen: false
      });
    }
  }, {
    key: "renderTimestamp",
    value: function renderTimestamp() {
      var _this$props = this.props,
          useEditableTimestamp = _this$props.useEditableTimestamp,
          canEdit = _this$props.canEdit,
          disableTimestamp = _this$props.disableTimestamp,
          timestamp = _this$props.timestamp;

      if (useEditableTimestamp && canEdit || disableTimestamp) {
        return null;
      }

      return _react.default.createElement(_UIColumn.default, null, _react.default.createElement(_UITooltip.default, {
        placement: "top",
        title: (0, _dateHelpers.formatTooltipString)(timestamp)
      }, _react.default.createElement(_Small.default, {
        use: "help",
        style: {
          height: '24px'
        },
        className: "p-left-4 display-flex align-center timeline-header-timestamp",
        "data-selenium-test": "timeline-header-timestamp"
      }, (0, _dateHelpers.formatMonthDayYearAtTimeString)(timestamp))));
    }
  }, {
    key: "renderActions",
    value: function renderActions() {
      return _react.default.createElement(_TimelineEventHeaderButtons.default, {
        canEdit: this.props.canEdit,
        className: this.getActionsClasses(),
        disableDelete: this.props.disableDelete,
        engagement: this.props.engagement,
        extraHeaderActions: this.props.extraHeaderActions,
        isCollapsed: !this.shouldShowActions(),
        objectTypesToAssociate: this.props.objectTypesToAssociate,
        onCloseSelect: this.handleCloseSelect,
        onDeleteConfirm: this.props.onDeleteConfirm,
        onOpenSelect: this.props.handleOpenSelect,
        style: this.getActionsHeight(),
        subject: this.props.subject,
        useDefaultAssociationSelect: this.props.useDefaultAssociationSelect,
        viewOnlyActions: this.props.viewOnlyActions
      });
    }
  }, {
    key: "renderActionsAndTimestamp",
    value: function renderActionsAndTimestamp() {
      if (!this.props.canEdit) {
        if (!this.props.viewOnlyActions) {
          return this.renderTimestamp();
        }
      }

      return _react.default.createElement(_UIColumnWrapper.default, {
        align: "center",
        className: "p-left-2 justify-end flex-wrap-reverse timeline-header-actions-and-timestamp"
      }, this.renderActions(), this.renderTimestamp());
    }
  }, {
    key: "renderTypeTitle",
    value: function renderTypeTitle() {
      return _react.default.createElement("b", {
        "data-selenium-test": "timeline-type"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.props.typeTitle,
        options: this.props.titleOptions
      }));
    }
  }, {
    key: "renderPin",
    value: function renderPin() {
      return _react.default.createElement(_UIIconCircle.default, {
        className: "pinned-card-icon",
        style: {
          top: '0'
        },
        name: "pin",
        color: _colors.OLAF,
        borderColor: _colors.LORAX,
        backgroundColor: _colors.LORAX,
        legacy: true,
        size: 17
      });
    }
  }, {
    key: "renderIcon",
    value: function renderIcon() {
      var icon = this.props.icon;
      return _react.default.createElement(_UIIcon.default, {
        className: "p-x-5",
        name: icon,
        color: _colors.SLINKY,
        size: 20,
        "data-onboarding": "timeline-item-icon-" + icon
      });
    }
  }, {
    key: "render",
    value: function render() {
      var isPinned = this.props.isPinned;
      return _react.default.createElement("div", {
        className: "display-flex",
        ref: this.timelineHeader
      }, _react.default.createElement(_UIColumnWrapper.default, {
        align: "start",
        className: "p-top-4 p-bottom-2"
      }, _react.default.createElement(_UIColumn.default, null, this.renderIcon()), _react.default.createElement(_UIColumn.default, null, this.renderTypeTitle()), _react.default.createElement(_UIColumnSpreads.default, {
        className: "align-end p-right-5"
      }, isPinned && this.renderPin(), this.renderActionsAndTimestamp())));
    }
  }]);
  return TimelineHeader;
}(_PureComponent2.default);

TimelineHeader.propTypes = propTypes;
TimelineHeader.defaultProps = defaultProps;
var _default = TimelineHeader;
exports.default = _default;
module.exports = exports.default;